<template>
  <div class="animated fadeIn">
    <h4 class="page-title">Dashboard</h4>
    <hr />
    <b-tabs>
      <b-tab title="User Login Stats" active>
        <spinner color="loader-dark-blue" v-if="isFetching.loginStats"></spinner>
        <b-row v-show="!isFetching.loginStats">
          <b-col sm="12" class="d-none d-md-block float-roght">
            <b-button-toolbar class="float-right">
              <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="loginStatsFilter" name="radiosBtn" @change="getLoginStats">
                <b-form-radio class="mx-0" value="daily">Daily</b-form-radio>
                <b-form-radio class="mx-0" value="monthly">Monthly</b-form-radio>
                <b-form-radio class="mx-0" value="yearly">Yearly</b-form-radio>
              </b-form-radio-group>
            </b-button-toolbar>
          </b-col>
        </b-row>
        <login-stats-chart :chart-data="loginStatsDatas" v-if="!isFetching.loginStats" class="mt-3" :height="300"/>
      </b-tab>

      <b-tab title="User Geo Location">
        <spinner color="loader-dark-blue" v-if="isFetching.geoStats"></spinner>
        <user-geo-stats style="height: 100%" class="mt-3" v-if="!isFetching.geoStats" :datas="geoStats" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { LoginStats as loginStatsChart, UserGeoStats } from '@/components/charts'
import { Spinner } from '@/components/'
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
import server from '@/services/server'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'dashboard',
  data () {
    return {
      loginStatsDatas: null,
      userGeoDatas: null,
      loginStatsLoaded: false,
      userGeoStatsLoaded: false,
      loginStatsFilter: 'daily'
    }
  },
  components: {
    loginStatsChart,
    UserGeoStats,
    Spinner
  },
  methods: {
    getLoginStats (filter) {
      const brandSuccess = getStyle('--success') || '#4dbd74'
      let promises = []

      this.$store.commit('dashboard/setIsFetching', {widget: 'loginStats', value: true})

      if (filter === 'daily') {
        promises.push(this.$store.cache.dispatch('dashboard/getDailyLoginStats', filter))
      } else if (filter === 'monthly') {
        promises.push(this.$store.cache.dispatch('dashboard/getMonthlyLoginStats', filter))
      } else {
        promises.push(this.$store.cache.dispatch('dashboard/getYearlyLoginStats', filter))
      }

      Promise.all(promises).then(
        resp => {
          let arr = this.loginStats[filter]
          this.loginStatsDatas = {
            labels: arr.map(obj => obj.DATE),
            datasets: [
              {
                label: 'User Login',
                backgroundColor: hexToRgba(brandSuccess, 10),
                borderColor: brandSuccess,
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                data: arr.map(obj => obj.COUNTER)
              }
            ]
          }
          // since we use vuex cache, we have to add timeout and give chart some "breathe" to re-render
          setTimeout(() => {
            this.$store.commit('dashboard/setIsFetching', {widget: 'loginStats', value: false})
          })
        }
      )
    },
    getUserGeoStats () {
      this.$store.commit('dashboard/setIsFetching', {widget: 'geoStats', value: true})
      this.$store.cache.dispatch('dashboard/getGeoStats').then(
        resp => {
          setTimeout(() => {
            this.$store.commit('dashboard/setIsFetching', {widget: 'geoStats', value: false})
          })
        }
      )
    }
  },
  computed: {
    ...mapState('dashboard', [
      'isFetching',
      'loginStats',
      'geoStats'
    ])
  },
  created () {
    this.getLoginStats('daily')
    this.getUserGeoStats()
  }
}
</script>
